import { Box, Card, Typography } from "@mui/material";


const ProjectItem = (props) => {
    return (
        <Card elevation={0}>
            <Box style={{paddingTop:"100%", position:"relative"}}>
                <img
                    src={props.imgUrl}
                    alt="project"
                    style={{width:"100%",height:"100%",position:"absolute",objectFit:"cover", top:0, left:0}}
                ></img>
            </Box>
            <Box p={3}>
                <Typography variant="h6" mb={0} fontWeight={600} textAlign="center">{props.title}</Typography>
            </Box>
        </Card>
    )
}

export default ProjectItem;
